import type { Building } from "building-types/building/buildingTypes";
import type { BuildingGeometryEmitter } from "building-types/geometry/buildingGeometryTypes";
import { FaceCategory } from "building-types/materials/faceCategories";
import { materialSrcFromPalette } from "doc/materialLookup";
import { faceGroupNew } from "geom/brep";
import { UVGeneration } from "geom/uv";
import { buildExteriorLayers } from "./buildingGeometryTools";

type ExteriorGeometry = "cornerBoards";
type BuildingForExteriorGeometries<T extends ExteriorGeometry> = Pick<Building, T | "exteriorPalette" | "levels">;

export function getCornerBoardGeometries(
  building: BuildingForExteriorGeometries<"cornerBoards">,
  emitter: BuildingGeometryEmitter,
): void {
  const { cornerBoards, exteriorPalette } = building;

  for (const cornerBoardId in cornerBoards) {
    const { levelId, faces: facesArrays } = cornerBoards[cornerBoardId];
    for (const {
      faces,
      entityId,
      entityHandleForSelectingReportingUnit,
      descriptor,
      material = "trimExterior0",
      pickHandle,
    } of facesArrays) {
      emitter.emit({
        geom: faceGroupNew(faces),
        faceCategory: FaceCategory.CORNER_BOARD,
        threeLayers: buildExteriorLayers(true),
        entityId,
        entityHandleForSelectingReportingUnit,
        levelId,
        descriptor,
        materialSlot: material,
        materialSrc: materialSrcFromPalette(exteriorPalette, material),
        uvGen: UVGeneration.GLOBAL_RECT_UV,
        pickHandle,
      });
    }
  }
}
